<template>
  <div class="detail-wrap">
    <div class="breadcrumb-wrap clearfix">
      <div class="wrapper">
        <div class="breadcrumb arrow inverted pull-left">
          <div class="start">当前位置：</div>
          <a href="index.html">首页</a>
          <div class="divider">&gt;</div>
          <a href="#">规章制度</a>
          <div class="divider">&gt;</div>
          <a href="#">信息详情</a>
        </div>
      </div>
    </div>
    <div class="detail-container clearfix">
      <div class="detail-content-wrap">
        <div class="title-wrap">
          <h3 class="h4">全国涉外法律服务高级研修班在深圳成功举办</h3>
          <p>
            <span>发表时间：2018-11-13</span>
            <span>来源：中国</span>
            <span>律师网作者：王晓丽</span>
          </p>
        </div>
        <div class="content">
          <div class="content-img">
            <img src="../../public/images/detail.png" alt="">
          </div>
          <p>11月5日至9日，在司法部政治部和律师工作局统法部政治部和律师工作局统法部政治部和律师工作局统法部政治部和律师工作局统法部政治部和律师工作局统一部署下，全国律协与司法部港澳台法律培训交流中心在深圳共同举办全国涉11月5日至9日，在司法部政治部和律师工作局统一部署下，全国律协与司法部港澳台法律培训交流中心在深圳共同举办全国涉11月5日至9日，在司法部政治部和律师工作局统一部署下，全国律协与司法部港澳台法律培训交流中心在深圳共同举办全国涉11月5日至9日，在司法部政治部和律师工作局统一部署下，全国律协与司法部港澳台法律培训交流中心在深圳共同举办全国涉</p>
          <p>11月5日至9日，在司法部政治部和律师工作局统一部署下，全国律协与司法部港澳台法律培训交流中心在深圳共同举法部政治部和律师工作局统法部政治部和律师工作局统办全国涉</p>
          <p>11月5日至9日，在司法部政治部和律师工作局统一部署下，全国律协与司法部港澳台法律培训交流中心在深圳共同举法部政治部和律师工作局统法部政治部和律师工作局统法部政治部和律师工作局统办全国涉</p>
          <p>11月5日至9日，在司法部政治部和律师工作局统一部署下，全国律协与司法部港澳台法律培训交流中心在深圳法部政治部和律师工作局统法部政治部和律师工作局统法部政治部和律师工作局统法部政治部和律师工作局统共同举办全国涉</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import mapChart from "../components/G2charts/map-chart.vue";
// import getpk from '../encrypt/getPassKey' // 获取密码加密函数
// console.log(getpk)
// import api from "../api/index";
export default {
  components: {
    mapChart
  },
  name: "home",
  data() {
    return {};
  },
  methods: {
    ...mapActions([])
  },
  watch: {
    allNumber(newVal) {
      console.log(newVal);
    }
  },
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
@import "../assets/scss/common";
.breadcrumb-wrap {
  padding: 25px 0;
  background-color: $white;
}
.detail-wrap {
  width: 100%;
  height: auto;
}
.breadcrumb-wrapper {
  width: 100%;
  background-color: $white;
}
.detail-container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding: 33px 85px 37px;
}
.detail-content-wrap {
  position: relative;
  padding: 40px 60px;
  width: 100%;
  height: auto;
  background-color: $white;
  border-radius: $border-radius;
  .h4 {
    margin-bottom: 15px;
    font-size: 20px;
    text-align: center;
  }
  .title-wrap {
    padding-bottom: 8px;
    text-align: center;
    border-bottom: 1px dotted $home-border;
  }
  .content {
    width: 100%;
    height: auto;
    .content-img {
      padding: 40px 0;
      width: 100%;
      text-align: center;
    }
    p {
      font-size: 16px;
      line-height: 35px;
      color: $gray-dark;
      text-indent: 2em;
    }
  }
}
</style>